import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useLanguage } from "@/context/LanguageContext";
import { useAuth, formatApiError } from "@/context/AuthContext";

export default function Register() {
  const { t, lang } = useLanguage();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, language: lang });
      toast.success("Welcome");
      navigate(params.get("next") || "/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-md mx-auto px-6">
        <div className="overline mb-3">{t("auth.create_account")}</div>
        <h1 className="font-serif text-4xl leading-tight text-ink font-light mb-10">
          {t("auth.register_title")}
        </h1>
        <form onSubmit={submit} data-testid="register-form" className="space-y-6">
          <Field label={t("contact.name")}>
            <input required value={form.name} onChange={upd("name")} data-testid="reg-name" className="fld" />
          </Field>
          <Field label={t("contact.email")}>
            <input required type="email" value={form.email} onChange={upd("email")} data-testid="reg-email" className="fld" />
          </Field>
          <Field label={t("contact.phone")}>
            <input value={form.phone} onChange={upd("phone")} data-testid="reg-phone" className="fld" />
          </Field>
          <Field label={t("auth.password")}>
            <input required type="password" minLength={6} value={form.password} onChange={upd("password")} data-testid="reg-password" className="fld" />
          </Field>
          <button type="submit" disabled={loading} data-testid="reg-submit"
            className="px-8 py-3 bg-ink text-bg text-xs uppercase tracking-widest2 hover:bg-accent transition-colors disabled:opacity-60">
            {loading ? "…" : t("auth.register_btn")}
          </button>
        </form>
        <div className="mt-10 text-sm text-muted">
          {t("auth.have_account")}{" "}
          <Link to="/login" className="underline underline-offset-4 text-ink">{t("auth.sign_in")}</Link>
        </div>
        <style>{`.fld{width:100%;background:transparent;border:0;border-bottom:1px solid #DDD8CD;padding:.5rem 0;outline:none;color:#141414;font-size:0.95rem}.fld:focus{border-color:#141414}`}</style>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="overline mb-2">{label}</div>
      {children}
    </label>
  );
}
